export const GOALS_MODAL_EXPERIMENT = {
  defaultVariant: 'control',
  flagName: 'experiment_learn-goals-modal-v1',
  pendo: {
    exposureEvent: 'experiment_exposure',
    visitorMetadataKey: 'experiment_goals_modal_v2',
  },
  variants: {
    CONTROL: 'control',
    DISABLE_SAVE_BUTTON: 'variant_disable_save_button',
  },
}
